import { z } from "zod";
import { ProcedureSchema } from "./Procedure";

export const UpdateProcedureRequestSchema = ProcedureSchema.pick({
    name: true,
    description: true,
    ownerId: true,
    startDate: true,
    endDate: true
}).extend({
    accountId: z.number().positive().min(1)
});

export type UpdateProcedureRequest = z.infer<typeof UpdateProcedureRequestSchema>;
